<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">输入手机号</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="apply-box">
            <div class="apply-value">
<!--                <input class="a-input" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" v-model="phone"-->
<!--                       placeholder="请输入对方手机号">-->
                <van-field oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" v-model="phone" placeholder="请输入对方手机号" />
            </div>
        </div>
        <div class="send-btn" @click="findMembers"><span class="btn-text">确认</span></div>
    </div>
</template>

<script>
    import {Notify} from 'vant';

    export default {
        name: 'phone',
        data() {
            return {
                phone: '',
            }
        },
        mounted() {
        },
        methods: {
            back() {
                this.$router.back();
            },
            toPrivilege() {
                this.$router.push({
                    name: 'privilege',
                    params: {
                        user: this.user
                    }
                })
            },
            findMembers() {
                if (this.phone.length < 11) return;
                this.$api.share.findMembers({
                    phone: this.phone
                }).then(res => {
                    let user = res.info;
                    localStorage.setItem("addUser", JSON.stringify(user));
                    this.$router.push({
                        name: 'confirm',
                        params: {
                            type: 'phone'
                        }
                    })
                }).catch(e => {
                    console.log(e);
                    Notify({type: 'danger', message: e.remark});
                })
            }
        }
    }
</script>

<style scoped>
    .apply-box {
        margin-top: 15px;
    }

    .apply-value {
        width: 345px;
        height: 44px;
        margin: 0 auto;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: #E9E9E9;
        font-size: 14px;
        caret-color: #20D38F;
    }

    /deep/ input::-webkit-input-placeholder{
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder{
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder{
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder{
        color: #FFFFFF;
        opacity: 0.6;
    }

    .send-btn {
        width: 311px;
        height: 44px;
        background: #20D38F;
        font-size: 15px;
        line-height: 44px;
        text-align: center;
        border-radius: 22px;
        position: absolute;
        bottom: 34px;
        left: 32px;
    }

    .btn-text {
        color: #FFFFFF;
        opacity: 0.9;
    }

    /deep/ .van-cell {
        background-color: #202020 !important;
        border-radius: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/phone.vue